module.exports = __webpack_public_path__ + "img/PRSI.f4b4c06e.png";